/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlAppSchemasAsmEntityVulnerabilitiesCount
 */
export interface ControlAppSchemasAsmEntityVulnerabilitiesCount {
    /**
     * 
     * @type {number}
     * @memberof ControlAppSchemasAsmEntityVulnerabilitiesCount
     */
    critical?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlAppSchemasAsmEntityVulnerabilitiesCount
     */
    high?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlAppSchemasAsmEntityVulnerabilitiesCount
     */
    medium?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlAppSchemasAsmEntityVulnerabilitiesCount
     */
    low?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlAppSchemasAsmEntityVulnerabilitiesCount
     */
    info?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlAppSchemasAsmEntityVulnerabilitiesCount
     */
    count?: number;
}

/**
 * Check if a given object implements the ControlAppSchemasAsmEntityVulnerabilitiesCount interface.
 */
export function instanceOfControlAppSchemasAsmEntityVulnerabilitiesCount(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlAppSchemasAsmEntityVulnerabilitiesCountFromJSON(json: any): ControlAppSchemasAsmEntityVulnerabilitiesCount {
    return ControlAppSchemasAsmEntityVulnerabilitiesCountFromJSONTyped(json, false);
}

export function ControlAppSchemasAsmEntityVulnerabilitiesCountFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlAppSchemasAsmEntityVulnerabilitiesCount {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'critical': !exists(json, 'critical') ? undefined : json['critical'],
        'high': !exists(json, 'high') ? undefined : json['high'],
        'medium': !exists(json, 'medium') ? undefined : json['medium'],
        'low': !exists(json, 'low') ? undefined : json['low'],
        'info': !exists(json, 'info') ? undefined : json['info'],
        'count': !exists(json, 'count') ? undefined : json['count'],
    };
}

export function ControlAppSchemasAsmEntityVulnerabilitiesCountToJSON(value?: ControlAppSchemasAsmEntityVulnerabilitiesCount | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'critical': value.critical,
        'high': value.high,
        'medium': value.medium,
        'low': value.low,
        'info': value.info,
        'count': value.count,
    };
}

